import { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import isModuleAndActionAvailable from "./is-module-and-action-available";
import ForbiddenComponent from "../error/forbidden.component";
import { useLocation } from "react-router-dom";

interface HasPermissionProps {
  moduleName: string;
  actionName: string;
  children: ReactNode;
  isRoute: boolean;
}

const HasPermission = ({
  moduleName,
  actionName,
  children,
  isRoute,
}: HasPermissionProps) => {
  const [isAvailable, setIsAvailable] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const location = useLocation();

  const modules = useSelector((state: any) => {
    return state.navbar.modules;
  });

  const getAvailableStatus = async () => {
    const isAvailable = await isModuleAndActionAvailable(
      moduleName,
      actionName,
      modules
    );
    setIsAvailable(isAvailable);
    setIsLoaded(true);
  };

  useEffect(() => {
    if (modules.length) {
      getAvailableStatus();
    }
  }, [modules, location]);

  return (
    <>
      {" "}
      {isLoaded ? (
        <>
          {isAvailable ? (
            <>{children}</>
          ) : isRoute ? (
            <>
              <ForbiddenComponent />
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default HasPermission;

export const useHasPermissionForAnyAction = (actionConfig: any[]): boolean => {
  const modules = useSelector((state: any) => state.navbar.modules); 
  const [hasPermission, setHasPermission] = useState<boolean>(false); 

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      if (!modules?.length || !actionConfig?.length) {
        if (mounted) setHasPermission(false);
        return;
      }

      for (const action of actionConfig) {
        if (action?.moduleName && action?.actionName) {
          const available = await isModuleAndActionAvailable(
            action.moduleName,
            action.actionName,
            modules,
          );
          if (available) {
            if (mounted) setHasPermission(true);
            return; 
          }
        }
      }

      if (mounted) setHasPermission(false);
    };

    check();

    return () => {
      mounted = false;
    };
  }, [modules, JSON.stringify(actionConfig)]);

  return hasPermission;
};
